export default __webpack_public_path__ + "static/media/Spectrum-Documentation.11f6d504.png";